import { render } from "./MessageItem.vue?vue&type=template&id=107b0abd&ts=true"
import script from "./MessageItem.vue?vue&type=script&lang=ts"
export * from "./MessageItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__